import React from 'react';

const Header = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', alignItems: 'center', paddingLeft: '20px', paddingRight: '40px', backgroundColor: '#343a40', color: '#fff', height: '70px' }}>
      <h1 style={{ fontSize: '24px', fontWeight: '700' }}>Beautcia Admin Dashboard</h1>
      <div style={{ padding: '3px 11px 0px 11px', borderRadius: '50px', backgroundColor: 'white', justifyContent: 'center', alignItems: 'center' }}>
        <h1 style={{ color: 'red', fontWeight: '700', fontSize: '28px'}}>B</h1>
          {/* <Image src={logo} alt="logo" width="23" height="46" /> */}
      </div>
    </div>
  );
};

export default Header;